export default __webpack_public_path__ + "static/app_store_footer.svg";